import React, { useState } from "react";
import Button from "@mui/material/Button";
import {
  Dialog,
  OutlinedInput,
  Typography,
  Stack,
  Box,
  DialogTitle,
  IconButton,
} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import "./index.scss";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Images } from "../../assets/common";
import Loader from "../Loader";
import { useEffect } from "react";
import ApiService from "../../services/api-service";

export default function LivestreamPayPopup(props) {
  const { t } = useTranslation("common");
  const [amount, setAmount] = React.useState("");
  const [value, setValue] = useState("payPal");
  const [sikiAmount, setSikiAmount] = React.useState(0);
  const [charge, setCharge] = React.useState({});
  const [minSikiNeeded, setMinSikiNeeded] = React.useState(0);

  // Fetch exchange rates from API
  const getCharges = async () => {
    try {
      const response = await ApiService.CHARGES();
      if (response["result"]) {
        setCharge({ ...response["result"] });
      }
    } catch (error) {
      console.error("Failed to fetch charges:", error);
    }
  };

  useEffect(() => {
    setAmount("");
    setSikiAmount(0);
    getCharges();
    if (props.minSikiNeeded) {
      setMinSikiNeeded(props.minSikiNeeded);
    }
  }, [props.open, props.minSikiNeeded]);

  useEffect(() => {
    if (amount && !isNaN(amount) && charge["rate"]) {
      // USD / rate = SIKI tokens (same logic as TipPopup)
      const tokens = (parseFloat(amount) / charge["rate"]).toFixed(2);
      setSikiAmount(tokens);
    } else {
      setSikiAmount(0);
    }
  }, [amount, charge]);

  const handleChange = (e) => {
    setValue(e);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        keepMounted
        // onClose={(props.handleClose, setValue(""))}
        onClose={() => {
          props.handleClose();
          setAmount("");
          setValue("moonPay");
        }}
        PaperProps={{
          style: {
            position: "relative",
            backgroundColor: "#090909",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            paddingBottom: "16px",
            // width: props.onlyPayPal ? "auto" : "33%",
            backgroundImage: "none",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <DialogTitle
            color="default"
            sx={{
              padding: "16px",
              color: "#ffffff",
              fontSize: "20px",
              borderBottom: "1px solid #1E1E1E",
            }}
          >
            {t("buySikiTokens")}
            <IconButton
              aria-label="close"
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
              onClick={() => {
                props.handleClose(false);
                setAmount("");
                setValue("moonPay");
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <Stack sx={{ padding: "16px", borderBottom: "1px solid #1E1E1E" }}>
            <Typography className="fs-14" mb="5px !important">
              {t("liveStreamPayPopup.text2")}
            </Typography>
            {minSikiNeeded > 0 && (
              <Typography
                sx={{
                  color: "#F48706",
                  fontSize: "14px !important",
                  fontWeight: 600,
                  marginBottom: "8px !important",
                }}
              >
                Minimum needed: {minSikiNeeded.toFixed(2)} SIKI tokens
              </Typography>
            )}
            <DialogContent sx={{ padding: 0 }}>
              <Box
                style={{
                  borderRadius: "25px",
                  border: "1px solid gray",
                  padding: "16.5px 14px",
                  backgroundColor: "#1E1E1E",
                }}
              >
                <Stack direction={"row"}>
                  <input
                    value={amount}
                    type="number"
                    onChange={(e) => setAmount(e.target.value)}
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }
                    style={{
                      border: "none",
                      minWidth: "200px",
                      width: "90%",
                      backgroundColor: "transparent",
                      color: "#ffffff",
                    }}
                    placeholder={
                      value == "payPal" || props.onlyPayPal
                        ? "Min. 4.99$"
                        : "Min. 30$"
                    }
                    autoFocus
                  />
                  <Typography
                    style={{
                      color: "gray",
                      fontSize: "12px",
                    }}
                    variant="body2"
                  >
                    USD
                  </Typography>
                </Stack>
              </Box>
            </DialogContent>

            {sikiAmount > 0 && (
              <Typography
                sx={{
                  color: "#F48706 !important",
                  padding: "8px 0",
                  fontSize: "14px !important",
                }}
              >
                You will receive: {Number(sikiAmount).toLocaleString()} SIKI tokens
              </Typography>
            )}

            {charge["rate"] && (
              <Typography
                sx={{
                  color: "#B0B0B0",
                  fontSize: "12px !important",
                  marginTop: "4px",
                }}
              >
                1 SIKI = ${charge["rate"].toFixed(4)} USD
              </Typography>
            )}

            {amount && amount < 4.99 ? (
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                mt={1}
                color="error"
              >
                Minimum amount is $4.99
              </Typography>
            ) : amount && amount > 20000 ? (
              <Typography
                variant="body2"
                sx={{ fontSize: "12px" }}
                mt={1}
                color="error"
              >
                {t("addSikiModal.text3")}
              </Typography>
            ) : null}

          </Stack>

          <Stack
            justifyContent="center"
            sx={{
              width: "50%",
              margin: "auto !important",
              marginTop: "8px !important",
            }}
          >
            {props.loading && !props.onlyPayPal ? (
              <Button style={{ backgroundColor: "tansparent !important" }}>
                <Loader
                  _class="__loader_inside_btn"
                  style={{ backgroundColor: "tansparent !important" }}
                />
              </Button>
            ) : (
              <Button
                onClick={() => {
                  if ((amount !== "" && value !== "") || props.onlyPayPal) {
                    props.handleSubmit(amount, value);
                  }
                }}
                title={t("liveStreamPayPopup.text5")}
                sx={{
                  height: "30px !importent",
                  fontWeight: "bold",
                }}
                variant="contained"
                color="primary"
              >
                {t("liveStreamPayPopup.text5")}
              </Button>
            )}
          </Stack>
        </Stack>
      </Dialog>
    </div>
  );
}
